
import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChange, SimpleChanges, Output, EventEmitter, OnDestroy,HostListener } from '@angular/core';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { Subject } from 'rxjs/internal/Subject';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { CommonService } from '../../services/common.service';

declare var jwplayer: any;
declare var TimeMe;
var inactivatetime = 0;
var intervalID;

@Component({
  selector: 'app-static-player',
  templateUrl: './static-player.component.html',
  styleUrls: ['./static-player.component.css']
})
export class StaticPlayerComponent implements OnInit, OnDestroy {
  ispopUpShow: boolean = false;
  private player: any;
  @Input() autoStart: boolean = false;
  @Input() isViewAble: boolean = true;
  @Input() isInPopup: boolean = true;
  @Input() thumb(thumb: string) {
    this._thumb = thumb;
    this.initialize();
  }
  _file: string;
  _thumb: string;
  @Input()
  set file(file: string) {
    this._file = file;
    this.initialize(file);
  }

  //@Input() height:string;
  // @Input() width:string;

  @Output() modelOpen = new EventEmitter<boolean>();
  @Output() navigateAfterDismiss = new EventEmitter();
  @Input() type: string;
  @Input() status: {};
  showButton = false;
  @Input() videoTitle;
  @Input() videoDesc;
  @Input() videoDuration;
  updatedCourse = false;
  @Input() masterVideoObj;
  reloadAgain = false;
  timeObservable = new Subject<number>();
  @Input() programIntroVideo;
  @Input() programEndVideo;
  @Input() item;
  timespentOnMasterclass = {};
  userActivity;
  userInactive: Subject<any> = new Subject();
  footerBtnText = '';
  playerStatus:boolean = false;

  constructor(private dashboardService: DashboardService,
              private commonService: CommonService ) { 
                this.setTimeout();
    this.userInactive.subscribe(() =>{});
  }


  ngOnInit() {
    if(this.masterVideoObj){
      this.timespentOnMasterclass['eventType'] = "PROG-MASTERCLASS";
      this.timespentOnMasterclass['programDashboardId'] = this.masterVideoObj['programDashboardId']; 
      this.timespentOnMasterclass['programActivationId'] = this.masterVideoObj['activationId'];
      this.timespentOnMasterclass['organization'] = this.masterVideoObj['organization'];
      this.timespentOnMasterclass['masterClassId'] = this.masterVideoObj['masterClassObjectId']; 
      this.timespentOnMasterclass['masterClassTitle'] = this.videoTitle;
    }
    this.updatedCourse = false;
    if ((this.type == 'COURSE' || this.type == 'INTEGRATION') && this.status['started'] == false) {
      this.showButton = true;
      if(this.type == 'COURSE') {
        this.footerBtnText = 'START COURSE';
      }
      else if(this.type == 'INTEGRATION') {
        this.footerBtnText = 'START';
      }
    }
    this.initialize();
    if(this.type == 'MASTERCLASS') {
      TimeMe.initialize({
        currentPageName: "MasterClass", // current page
      });
      TimeMe.startTimer();
      this.saveMasterclassVideoTime();
    }
  }

  saveMasterclassVideoTime() {
    this.timeObservable.pipe(debounceTime(3000)).subscribe((position) => {
      let data = { 
        activationId: this.masterVideoObj.activationId, programDashboardId: this.masterVideoObj.programDashboardId, activationDashboardType: 'MASTERCLASS',
        masterClassObjectId: this.masterVideoObj.masterClassObjectId, viewedTime: position 
      };
      this.dashboardService.masterclassViewedTimeSave(data).pipe(debounceTime(3000)).subscribe();
    });
  }

  initialize(url?) {
    // get srts data
    if(url && this.type != 'MASTERCLASS') {
      let data = {contentUrl: url, contentId: ''}
      this.dashboardService.getSRTSData(data).subscribe((res) => {
        if(res) {
          let tracks = this.updateTrack(res);
          this.initializePlayer(tracks);
        }
      }, (err) =>  {
        this.initializePlayer();
        console.log(err);
      })  
    } else {
      this.initializePlayer();
    }
  }

  initializePlayer(tracks?) {
    setTimeout(() => {
      this.player = jwplayer("myDiv").setup({
        "file": this._file,
        image: this._thumb,
        // "height": this.height,
        //"width": this.width,
        height: '100%',
        width: '100%',
        "aspectratio": '16:9',
        "autostart": this.autoStart,
        "repeat": false,
        "primary": 'html5',
        "stretching": "uniform",
        renderCaptionsNatively: false,
        tracks: tracks
      }).setCaptions({ 'fontSize': 12, 'backgroundOpacity': 100, 'backgroundColor': '#000000', 'fontFamily': 'Arial' });

      this.player.on('firstFrame', function () {
        console.log("FIRST TIME PLAY");
        TimeMe.startTimer();
        /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
        amplitude.getInstance().setUserId('anonymous');
        amplitude.getInstance().logEvent('Play a vedio', { 'vedioName': this._file }); */
        /* mixpanel.track("Play a vedio",
          { 'vedioName': this._file }); */
      });
      this.isViewAble && this.player.on('viewable', () => {
        !this.player.getViewable() && this.player.pause();
      });

      this.player.on("time", ({ position, duration }) => {
        // let play_time = TimeMe.getTimeOnCurrentPageInSeconds();
        if ((Math.floor(position) % 30 === 0) && this.type == 'MASTERCLASS') {
          this.timeObservable.next(position);
        }
        if (!this.updatedCourse && this.status && this.status['progress'] < 100 && (this.videoDuration && (position >= 0.9 * this.videoDuration)) && this.type == 'MASTERCLASS') {
          this.updatedCourse = true;
          this.recordingCompletion();
        }
      });

      this.player.on('ready', (data) => {
        let viewedTime = 0;
        let threshold = 0;
        if (this.masterVideoObj && this.masterVideoObj.viewedTime) {
          viewedTime = this.masterVideoObj.viewedTime;
        }
        for (let x = 30; x < this.videoDuration; x = x + 30) {
          threshold = x;
        }
        if (viewedTime == this.videoDuration || threshold == 0 || (viewedTime > (threshold - 10))) {
          this.player.seek(0);
        } 
        else {
          this.player.seek(viewedTime);
        }
        this.player.setMute(false);
      });
      this.player.on('play', () => {
        this.playerStatus = true;
        TimeMe.startTimer();
      })

      this.player.on('pause', () => {
        this.playerStatus = false;
        // TimeMe.stopTimer();
      })
    }, 500)
  }


  recordingCompletion() {
    let data = { 
      activationId: this.masterVideoObj.activationId, programDashboardId: this.masterVideoObj.programDashboardId, activationDashboardType: 'MASTERCLASS',
      masterClassObjectId: this.masterVideoObj.masterClassObjectId, completeProgress: true 
    };

    this.dashboardService.masterclassThreshold(data).pipe(debounceTime(100000), distinctUntilChanged()).subscribe((res) => {
      if(res) {
        this.reloadAgain = true;
      }
    });
  }


  closePop() {
    this.modelOpen.emit(this.reloadAgain);
  }

  msgToParent() {
    this.modelOpen.emit(true);
  }

  // timeLeaveTab = TimeMe.callWhenUserLeaves(function(){
  //   TimeMe.stopTimer();
  // },15);

  // timeOnreturnTab = TimeMe.callWhenUserReturns(function(){
  //   // TimeMe.initialize();
  //   // TimeMe.startTimer();
  // });

  setTimeout() {
    clearInterval(intervalID);
    inactivatetime = 0;
    this.userActivity = setTimeout(
      () => {
        if(!this.playerStatus){
          this.userInactive.next(undefined);
          this.calculateTimesession(TimeMe.getTimeOnCurrentPageInSeconds());
          TimeMe.resetAllRecordedPageTimes();
          TimeMe.initialize();
          TimeMe.startTimer(); 

          intervalID = setInterval(()=>{
            console.log("INTERVAL");
            inactivatetime= inactivatetime+1;
            if(inactivatetime >= 900){
              clearInterval(intervalID);
              TimeMe.resetAllRecordedPageTimes();
              TimeMe.initialize();
            }
          }, 1000);
        }
      },
      1000*60*2
    );
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearInterval(intervalID);
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  // @HostListener('window:blur', ['$event'])
  //  onBlur(event: FocusEvent): void { 
  //   this.calculateTimesession(TimeMe.getTimeOnCurrentPageInSeconds());
  //   TimeMe.resetAllRecordedPageTimes();
  // }

  calculateTimesession(spent_time){
    this.setTimetrackingOnPlayerdpage(spent_time);
  }

  setTimetrackingOnPlayerdpage(calcTime){
    let timeOnMasterClass = +(this.masterVideoObj?.masterClassDuration) + 600;
    if(calcTime > 0 && this.type == 'MASTERCLASS' && this.masterVideoObj){
      if(calcTime > timeOnMasterClass){
        this.timespentOnMasterclass['spentTime'] = timeOnMasterClass;
      } else{
        this.timespentOnMasterclass['spentTime'] = calcTime;
      }
      this.commonService.saveTimespentonPages(this.timespentOnMasterclass).subscribe(resp => {
        TimeMe.resetAllRecordedPageTimes();
      })
    }
  }

  updateTrack(data) {
    let tracks = [];
    if(data['multipleSrts'] && data['multipleSrts'].length){
      data['multipleSrts'].forEach((val,ind) =>{
        tracks.push({
          file: val.url,
          label: val.language,
          kind: "captions",
          "default": false
        })
        if(ind == 0){
          tracks[0]['default'] = true
        }
      });

    }
    else if(data.srts && data.srts.length && data.srts[0]){
      /* if ((hindiCourse === "EXECUTING SOLUTIONS HINDI" || hindiCourse === "MANAGING TEAMWORK HINDI")) {
        tracks.push({ file: data.srts[0], label: "Hindi", kind: "captions", "default": true });
      } */
      // else  {
        tracks.push({ file: data.srts[0], label: "English", kind: "captions", "default": true });      
      // }
    }
    return tracks;
  }


  ngOnDestroy(){
    this.calculateTimesession(TimeMe.getTimeOnCurrentPageInSeconds());
    // if(this.type == 'MASTERCLASS'){
    //   this.timespentOnMasterclass['spentTime'] = TimeMe.getTimeOnCurrentPageInSeconds();
    //   this.commonService.saveTimespentonPages(this.timespentOnMasterclass).subscribe(resp => {
    //   })
    // }
  }

}